import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

/**
 * 查看当前的投诉列表信息
 * @param current 查询条件
 * @param size 条数
 */

export function getComplaintList(data){
    return request({
        url:`/${systemConfig.unpaidWagesPrefix}/backpayComplaintInfo/gl/v1.0.0/page`,
        method:"post",
        data
    })
}
/**
 * 进行分派提供的信息
 * @param data 分派信息
 */

export function dispatchInfo(data){
    return request({
        url:`/${systemConfig.unpaidWagesPrefix}/backpayComplaintInfo/gl/v1.0.0/assign`,
        method:"post",
        data
    })
}

/**
 * 获取分派列表 
 * */
export function getDispatchList(data){
    return request({
        url:`/${systemConfig.unpaidWagesPrefix}/backpayComplaintInfo/gl/v1.0.0/getDeptListByType`,
        method:"post",
        data
    })
}

/**
 * 进行标记无效
 */

export function invalidComplaint(data) {
    return request({
        url:`/${systemConfig.unpaidWagesPrefix}/backpayComplaintInfo/gl/v1.0.0/validInvalid`,
        method: "post",
        data
    })
}

/**
 * 获取投诉详情信息
 */
export function getComplaintDetail(data) {
    return request({
      url:`/${systemConfig.unpaidWagesPrefix}/backpayComplaintInfo/gl/v1.0.0/detail`,
      method: "post",
      data
    })
}
  
/**
 * 获取处置信息
 */
export function getRecodList(data) {
    return request({
     url:`/${systemConfig.unpaidWagesPrefix}/backpayComplaintRecord/gl/v1.0.0/list`,
     method: "post",
     data
    })
  }

/**
 * 进行审核
 */

export function requestFeedBackAudit(data) {
    return request({
        url: `/${systemConfig.unpaidWagesPrefix}/backpayComplaintInfo/gl/v1.0.0/feedbackAudit`,
        method: "post",
        data
    })
}
  
/**
* 退回
*/

export function getBack(data){
    return request({
      url: `/${systemConfig.unpaidWagesPrefix}/backpayComplaintInfo/gl/v1.0.0/sendBack`,
      method: "post",
      data
    })
}

/***
 * 结案
 */
export function getEnd(data){
    return request({
      url: `/${systemConfig.unpaidWagesPrefix}/backpayComplaintInfo/gl/v1.0.0/case`,
      method: "post",
      data
    })
}

/**
 * 进行提交
 */
export function submitDisposal(data) {
    return request({
      url: `/${systemConfig.unpaidWagesPrefix}/backpayComplaintInfo/gl/v1.0.0/process`,
      method: "post",
      data,
    })
}

/**
 * 导入项目
 */
export function importProject(data) {
    return request({
      url: `/${systemConfig.unpaidWagesPrefix}/backpayProjectInfo/gl/v1.0.0/projectImport`,
      method: "post",
      data,
    })
}

/**
 * 导入投诉
 */
export function importComplaint(data) {
    return request({
      url: `/${systemConfig.unpaidWagesPrefix}/backpayComplaintInfo/gl/v1.0.0/complaintImport`,
      method: "post",
      data,
    })
}


/**
 * 导出投诉
 * 
 * */
export function exportComplaintInfo(data) {
    return request({
        url: `/${systemConfig.unpaidWagesPrefix}/backpayComplaintInfo/gl/v1.0.0/complaintInfoExport`,
        method: 'post',
        data,
        responseType: 'blob'
    })
}